<template>
  <div class="auth-test">
    <v-card class="mx-auto" max-width="600">
      <v-card-title>
        🔐 Prueba de Sistema de Autenticación
      </v-card-title>
      
      <v-card-text>
        <v-alert
          :type="authStatus.type"
          :icon="authStatus.icon"
          prominent
        >
          {{ authStatus.message }}
        </v-alert>

        <v-divider class="my-4"></v-divider>

        <v-list>
          <v-list-item>
            <template v-slot:prepend>
              <v-icon :color="isAuthenticated ? 'green' : 'red'">
                {{ isAuthenticated ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </template>
            <v-list-item-title>Estado de Autenticación</v-list-item-title>
            <v-list-item-subtitle>
              {{ isAuthenticated ? 'Autenticado' : 'No autenticado' }}
            </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon :color="hasAccessToken ? 'green' : 'red'">
                {{ hasAccessToken ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </template>
            <v-list-item-title>Access Token</v-list-item-title>
            <v-list-item-subtitle>
              {{ hasAccessToken ? 'Presente' : 'Ausente' }}
            </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon :color="hasRefreshToken ? 'green' : 'red'">
                {{ hasRefreshToken ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </template>
            <v-list-item-title>Refresh Token</v-list-item-title>
            <v-list-item-subtitle>
              {{ hasRefreshToken ? 'Presente' : 'Ausente' }}
            </v-list-item-subtitle>
          </v-list-item>

          <v-list-item>
            <template v-slot:prepend>
              <v-icon :color="tokenExpiringSoon ? 'orange' : 'green'">
                {{ tokenExpiringSoon ? 'mdi-alert' : 'mdi-check-circle' }}
              </v-icon>
            </template>
            <v-list-item-title>Estado del Token</v-list-item-title>
            <v-list-item-subtitle>
              {{ tokenExpiringSoon ? 'Expirando pronto' : 'Válido' }}
            </v-list-item-subtitle>
          </v-list-item>
        </v-list>

        <v-divider class="my-4"></v-divider>

        <v-btn
          color="primary"
          @click="testApiCall"
          :loading="testingApi"
          block
        >
          🧪 Probar Llamada API
        </v-btn>

        <v-btn
          color="error"
          @click="testLogout"
          class="mt-2"
          block
        >
          🚪 Probar Logout
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { isTokenExpiringSoon, logout } from '@/services/apiMonolito';
import apiMonolito from '@/services/apiMonolito';

export default {
  name: 'AuthTest',
  data() {
    return {
      testingApi: false
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    hasAccessToken() {
      return !!this.$store.getters.accessToken;
    },
    hasRefreshToken() {
      return !!this.$store.getters.refreshToken;
    },
    tokenExpiringSoon() {
      return isTokenExpiringSoon();
    },
    authStatus() {
      if (this.isAuthenticated) {
        return {
          type: 'success',
          icon: 'mdi-shield-check',
          message: '✅ Sistema de autenticación funcionando correctamente'
        };
      } else {
        return {
          type: 'warning',
          icon: 'mdi-shield-alert',
          message: '⚠️ Usuario no autenticado - Inicia sesión para probar'
        };
      }
    }
  },
  methods: {
    async testApiCall() {
      this.testingApi = true;
      try {
        // Intentar hacer una llamada API simple para probar conectividad
        // Usamos un endpoint que no requiere autenticación
        const response = await apiMonolito.get('/health');
        this.$store.commit('showSnackbar', {
          text: '✅ Llamada API exitosa - Servidor accesible',
          color: 'success'
        });
      } catch (error) {
        // Si el endpoint /health no existe, probamos con una petición simple
        if (error.response && error.response.status === 404) {
          this.$store.commit('showSnackbar', {
            text: '⚠️ Servidor accesible pero endpoint no encontrado',
            color: 'warning'
          });
        } else {
          this.$store.commit('showSnackbar', {
            text: `❌ Error de conectividad: ${error.message}`,
            color: 'error'
          });
        }
      } finally {
        this.testingApi = false;
      }
    },
    testLogout() {
      logout();
      this.$store.commit('showSnackbar', {
        text: '🚪 Logout ejecutado correctamente',
        color: 'info'
      });
    }
  }
};
</script>

<style scoped>
.auth-test {
  padding: 20px;
}
</style> 